<template>
  <div>
    <ExpandableSettingsItem :title="$t('message.MEMBERS')">
      <div>
        <div class="generic-background">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="field-hint data-usage" v-html="$t('message.SETTINGS_USER_DATA_USAGE')" />
          <SettingsMemberItem
            v-for="user in users"
            :ref="userRef + user.id"
            :key="user.id"
            :user="user"
            :all-users="App.thisTeamUsers"
          />
        </div>
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.LOCATION')">
      <TreeField
        v-if="zoneValue !== undefined && zoneValue !== false"
        v-model="zoneValue"
        :legend="`${$t('message.LOCATION')}${$t('message.TWO_DOTS')}`"
        :items="zones"
        :placeholder="$t('message.LOCATION_CLICK_HINT')"
        @okClick="saveZone"
      />
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.WORKING_HOURS')">
      <div>
        <div>
          <span class="legend">{{ $t('message.DAY_START') + $t('message.TWO_DOTS') }}</span>
          <VueTimepicker
            v-model="dayStart"
            class="ml10"
            format="HH:mm"
            :minute-interval="5"
            @input="setWorkingHours"
          />
        </div>
        <div class="mt10">
          <span class="legend">{{ $t('message.DAY_END') + $t('message.TWO_DOTS') }}</span>
          <VueTimepicker
            v-model="dayEnd"
            class="ml10"
            format="HH:mm"
            :minute-interval="5"
            @input="setWorkingHours"
          />
        </div>
      </div>
    </ExpandableSettingsItem>
    <ExpandableSettingsItem :title="$t('message.LOGIN_PWD')">
      <div>
        <PwdEditForm
          ref="pwd"
          :index="1"
          :expandable="false"
          @submit="updatePwd"
        />
      </div>
    </ExpandableSettingsItem>
  </div>
</template>

<script>
import toastr from 'toastr';
// Vuex
import { mapState } from 'vuex';
import VueTimepicker from 'vue2-timepicker';
import { FETCH_ZONES, SET_TEAM_PARAM, FETCH_USERS } from '@/store/action-types';
import { GET_ZONES, GET_USERS } from '@/store/mutation-types';
// Components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import PwdEditForm from '@/components/pwd-edit-form.vue';
import SettingsMemberItem from '@/components/settings-member-item.vue';
import TreeField from '@/components/tree-field.vue';
// Utils
import { calert, preventPastingStyles } from '@/utils/main';


export default {

  name: 'SettingsTeam',

  components: {
    ExpandableSettingsItem,
    PwdEditForm,
    SettingsMemberItem,
    VueTimepicker,
    TreeField,
  },

  data() {
    return {
      userRef: 'userRef',
      dayStart: { HH: '07', mm: '00' },
      dayEnd: { HH: '20', mm: '00' },
      updatingPassword: false,
      zoneValue: 0,
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_TEAM'),
    };
  },

  computed: {
    ...mapState({
      zones: state => state[GET_ZONES.stateKey] || [],
      zonesLoading: state => state[GET_ZONES.loadingKey],
      users: state => state[GET_USERS.stateKey] || [],
      usersLoading: state => state[GET_USERS.loadingKey],
    }),
  },

  watch: {
    currentTeam: {
      deep: true,
      handler() {
        this.zoneValue = this.currentTeam.zone;
      },
    },
  },

  created() {
    this.zoneValue = this.currentTeam.zone;
  },

  beforeRouteEnter(to, from, next) {
    next((comp) => {
      comp.refresh();
    });
  },

  methods: {
    refresh() {
      if (!this.usersLoading) {
        this.$store.dispatch(FETCH_USERS).then(() => {
          this.$nextTick(preventPastingStyles);
        });
      }
      if (!this.zonesLoading) {
        this.$store.dispatch(FETCH_ZONES);
      }
      this.refreshWorkingHours();
    },
    /** Fetch team's working hours */
    refreshWorkingHours() {
      this.$http.get('/server/team/parameters').then(({ data }) => {
        if (data instanceof Object && data.dayStart && data.dayEnd) {
          const ds = data.dayStart.split(':');
          const de = data.dayEnd.split(':');
          this.dayStart = { HH: ds[0], mm: ds[1] };
          this.dayEnd = { HH: de[0], mm: de[1] };
        }
      });
    },
    /** Edit working hours settings */
    setWorkingHours() {
      const params = {
        dayStart: `${this.dayStart.HH}:${this.dayStart.mm}`,
        dayEnd: `${this.dayEnd.HH}:${this.dayEnd.mm}`,
      };
      this.$store.dispatch(SET_TEAM_PARAM, params);
    },
    saveZone() {
      this.$store.dispatch(SET_TEAM_PARAM, { zone: this.zoneValue });
    },
    /** Updates the password and sends to server */
    updatePwd(passFormer, passNew, passNewConfirm) {
      if (this.updatingPassword) {
        return;
      }
      const len = passNew.length;
      if (len < 8 || len > 25) {
        calert(this.$t('message.PWD_BETWEEN_8_25'), [{ title: this.$t('message.OK') }]);
        return;
      }
      if (passNewConfirm !== passNew) {
        calert(this.$t('message.PWD_DONT_MATCH'), [{ title: this.$t('message.OK') }]);
        return;
      }
      this.updatingPassword = true;
      // Send to server
      this.$http.post('/server/teams/editPwd.php', { former: passFormer, new: passNew })
        .then((response) => {
          this.updatingPassword = false;
          if (response && response.data === 1) {
            calert(this.$t('message.PWD_EDITED'));
          } else {
            toastr.error(this.$t('message.PWD_ERROR_CHECK'));
          }
        })
        .catch(() => {
          this.updatingPassword = false;
        });
    },
  },
};
</script>

<style lang="scss">
.data-usage {
  margin-bottom: 1.6em;

  ul {
    margin: 0.5em 0px;
    padding-left: 10px;
  }
}
</style>
